
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200 200"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M139.296 33a20 20 0 0119.09 14.035l11.199 35.836A97 97 0 01174 111.803V140c0 7.403-4.022 13.866-10 17.324V178h-19v-18H55v18H36v-20.675c-5.978-3.458-10-9.922-10-17.325v-28.197a97 97 0 014.415-28.932l11.2-35.836A20 20 0 0160.703 33h78.592zM45 109a9 9 0 100 18 9 9 0 000-18zm110 0a9 9 0 100 18 9 9 0 000-18zm-12.387-67H57.387a6 6 0 00-5.717 4.18l-10.182 32A6 6 0 0047.205 86h105.59a6 6 0 005.717-7.82l-10.182-32a6 6 0 00-5.717-4.18z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    